import Slider from "react-slick";
import styled from "styled-components";

export const Carousel = styled(Slider)`
  margin-top: 20px;
  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;
    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }
  ul li button {
    &:before {
      font-size: 10px;
      color: rgb(150, 158, 171);
    }
  }
  li.slick-active button:before {
    color: white;
  }
  .slick-list {
    overflow: initial;
  }
  .slick-prev {
    left: -75px;
  }
  .slick-next {
    right: -75;
  }
`;

export const CarouselWrapper = styled.div`
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  a {
    border-radius: 6px;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
      rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    cursor: pointer;
    display: block;
    position: relative;
    padding: 4px;
  }
  img {
    width: 100%;
    height: 100%;
  }
  &:hover {
    padding: 2;
    border: 4px solid rgb(249, 249, 249, 0.8);
    transition-duration: 300ms;
  }
`;
